import { type BadgeStatus, StatusBadge } from "@/components/ui/status-badge";
import { cn } from "@/lib/utils";

// Staffing request / line lifecycle → NOS StatusBadge semantics, per the
// CONVERSION_PLAN §1i status→ramp mapping (blue→info, amber→warning/pending,
// violet→brand, emerald→success/completed, zinc→muted/disabled, red→error/failed).
const STATUS_TO_NOS: Record<string, BadgeStatus> = {
  New: "info",
  Mapping: "pending",
  Unmapped: "pending",
  Mapped: "brand",
  Committed: "completed",
  Rejected: "disabled",
  Superseded: "disabled",
  Error: "failed",
};

interface StaffingStatusBadgeProps {
  status: string;
  className?: string;
}

/** Compact status pill for the request queue + mapping tables (dense rows). */
export function StaffingStatusBadge({ status, className }: StaffingStatusBadgeProps) {
  return (
    <StatusBadge
      status={STATUS_TO_NOS[status] ?? "disabled"}
      className={cn("h-5 px-1.5 text-[10px] font-semibold", className)}
    >
      {status}
    </StatusBadge>
  );
}
